import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, ChevronDown, ChevronUp, Newspaper } from "lucide-react";
import { useI18n } from "../i18n";

// Press articles — featured first 3, rest collapsed
const ARTICLES = [
  // FEATURED
  {
    source: "Steppe News",
    date: "2025",
    title_ru:
      "Финал с привкусом споров: как команда Астана покорила зрителей и почему соцсети негодуют",
    title_en:
      "A finale with a hint of controversy: how Team Astana won the audience over",
    url: "https://steppenews.kz/glavnaya/final-s-privkusom-sporov-kak-komanda-astana-pokorila-zritelej-i-pochemu-soczseti-negoduyut/",
    featured: true,
  },
  {
    source: "Central Media 24",
    date: "2025",
    title_ru:
      "Челлендж лысых: казахстанцы массово бреются в поддержку команды Астана после финала шоу «Звёзды»",
    title_en:
      "The Bald Challenge: Kazakhstanis shave their heads to support Team Astana after the «Zvyozdy» finale",
    url: "https://centralmedia24.kz/chellendzh-lysyh-kazahstanczy-massovo-breyutsya-v-podderzhku-komandy-astana-posle-finala-shou-zvezdy/",
    featured: true,
  },
  {
    source: "Tengrinews",
    date: "2017",
    title_ru: "«Мы плакали на сцене»: как «Спарта» выиграла Высшую лигу КВН",
    title_en:
      "“We cried on stage”: how «Sparta» won the KVN Major League",
    url: "https://tengrinews.kz/kazakhstan_news/my-plakali-na-scene-kak-sparta-vyigrala-vyssuiu-ligu-kvn-333446/",
    featured: true,
  },
  // REST
  {
    source: "Humorpedia",
    date: "—",
    title_ru: "Team Astana — Звёзды НТВ: профиль команды",
    title_en: "Team Astana — Stars of NTV: team profile",
    url: "https://humorpedia.ru/zvezdy-ntv/team/astana.html",
  },
  {
    source: "Threads · @dianathenumber1",
    date: "2025",
    title_ru: "Пост о выступлении команды Астана",
    title_en: "Post about Team Astana's performance",
    url: "https://www.threads.com/@dianathenumber1/post/DS9QT5YiIb0?xmt=AQG0Lc-u3irHIaRsZhnIxYp3hddUSHbCjDM7gnGkclZih0HfETrsyx9GgFd_oM1WW0ZFEkA",
  },
  {
    source: "Aikyn",
    date: "2025",
    title_ru:
      "Команда Астана рассказала, как они попали в шоу на ТНТ",
    title_en: "Team Astana on how they got onto the TNT show",
    url: "https://ru.aikyn.kz/komanda-astana-rasskazala-kak-oni-popali-v-shou-na-tnt/",
  },
  {
    source: "Humorpedia",
    date: "—",
    title_ru: "Команда КВН «Спарта» — профиль на Humorpedia",
    title_en: "KVN team «Sparta» — Humorpedia profile",
    url: "https://humorpedia.ru/kvn/team/sparta.html",
  },
  {
    source: "Zakon.kz",
    date: "2016",
    title_ru:
      "Команда КВН «Спарта» из Астаны стала вице-чемпионом Высшей лиги",
    title_en:
      "Astana's KVN team «Sparta» becomes Major League vice-champion",
    url: "https://www.zakon.kz/kultura-shoubiz/4595076-komanda-kvn-sparta-iz-astany-stala-vice.html",
  },
  {
    source: "BAQ.KZ",
    date: "2016",
    title_ru:
      "«Спарта» из Астаны стала второй в финале Высшей лиги КВН",
    title_en: "«Sparta» of Astana finishes 2nd in the KVN Major League final",
    url: "https://rus.baq.kz/sparta_iz_astani_stala_vtoroi_v_finale_visshei_ligi_kvn_48601/",
  },
  {
    source: "Informburo",
    date: "2017",
    title_ru:
      "Казахстанская команда впервые стала чемпионом Высшей лиги КВН",
    title_en:
      "Kazakhstani team becomes champion of the KVN Major League for the first time",
    url: "https://informburo.kz/novosti/kazahstanskaya-komanda-vpervye-stala-chempionom-vysshey-ligi-kvn.html",
  },
  {
    source: "Sputnik Kazakhstan",
    date: "2017",
    title_ru: "Команда «Спарта» стала чемпионом Высшей лиги КВН",
    title_en: "Team «Sparta» becomes KVN Major League champion",
    url: "https://ru.sputnik.kz/20171216/komanda-sparta-stala-chempionom-vysshej-ligi-kvn-4056986.html",
  },
  {
    source: "Tengrinews",
    date: "2016",
    title_ru:
      "Команда КВН «Спарта» из Астаны стала вице-чемпионом Высшей лиги",
    title_en:
      "Astana's «Sparta» becomes vice-champion of the KVN Major League",
    url: "https://tengrinews.kz/story/komanda-kvn-sparta-astany-stala-vice-cempionom-vyssei-245683/",
  },
  {
    source: "Caravan",
    date: "2017",
    title_ru:
      "Команда «Спарта» из Астаны выиграла 18-ю Высшую лигу КВН 2017",
    title_en: "«Sparta» of Astana wins the 18th KVN Major League, 2017",
    url: "https://www.caravan.kz/news/komanda-sparta-iz-astany-vyigrala-18-vysshejj-ligi-kvn-2017-390575/",
  },
  {
    source: "Yvision",
    date: "—",
    title_ru: "Знакомьтесь — команда КВН «Спарта»",
    title_en: "Meet the KVN team «Sparta»",
    url: "https://yvision.kz/post/znakomtes-komanda-kvn-sparta-396205",
  },
  {
    source: "NewTimes.kz",
    date: "—",
    title_ru:
      "Команда КВН «Спарта» вышла в полуфинал Высшей лиги",
    title_en: "KVN team «Sparta» reaches the Major League semi-final",
    url: "https://newtimes.kz/ekonomika/50684-komanda-kvn-sparta-vyshla-v-polufinal-vysshej-ligi",
  },
];

const Press = () => {
  const { t, lang } = useI18n();
  const [expanded, setExpanded] = useState(false);

  const featured = ARTICLES.filter((a) => a.featured);
  const rest = ARTICLES.filter((a) => !a.featured);

  const title = (a) => (lang === "ru" ? a.title_ru : a.title_en);

  return (
    <section id="press" data-testid="press-section" className="relative py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="mb-14">
          <div className="kicker mb-4">{t.press.kicker}</div>
          <h2
            className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter"
            data-testid="press-title"
          >
            {t.press.title}
          </h2>
          <p className="mt-4 text-white/55 max-w-md text-sm">
            {lang === "ru"
              ? "Подборка статей и публикаций о команде Астана в казахстанских и международных СМИ."
              : "A selection of articles and publications about Team Astana in Kazakhstani and international media."}
          </p>
        </div>

        {/* Featured — 3 big cards */}
        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/15 border border-white/15"
          data-testid="press-featured"
        >
          {featured.map((a, i) => (
            <motion.a
              key={a.url}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group relative bg-[#0a0a0a]/85 backdrop-blur-sm p-7 md:p-9 flex flex-col gap-5 hover:bg-[#150003] transition-colors min-h-[320px]"
              data-testid={`press-featured-${i}`}
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-2 text-[10px] tracking-[0.3em] uppercase text-white/45">
                  <Newspaper size={12} className="text-[#FFDE00]" />
                  <span className="text-[#FFDE00]/90 font-semibold">
                    {a.source}
                  </span>
                  <span className="text-white/30">· {a.date}</span>
                </div>
                <ArrowUpRight
                  size={18}
                  className="text-white/30 group-hover:text-[#FFDE00] group-hover:rotate-12 transition-all"
                />
              </div>
              <h3 className="font-display text-2xl md:text-[28px] leading-[1.05] tracking-tight text-white group-hover:text-[#FFDE00] transition-colors flex-1">
                {title(a)}
              </h3>
              <div className="text-[11px] tracking-widest uppercase text-white/45 border-t border-white/10 pt-4 inline-flex items-center gap-2">
                {lang === "ru" ? "Читать статью" : "Read article"}
                <span className="text-[#FFDE00]">→</span>
              </div>
            </motion.a>
          ))}
        </div>

        {/* Rest — expandable list */}
        {rest.length > 0 && (
          <>
            <AnimatePresence initial={false}>
              {expanded && (
                <motion.div
                  key="press-rest"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.45, ease: [0.2, 0.7, 0.2, 1] }}
                  className="overflow-hidden"
                >
                  <div
                    className="mt-px grid grid-cols-1 md:grid-cols-2 gap-px bg-white/15 border-x border-b border-white/15"
                    data-testid="press-list"
                  >
                    {rest.map((a, i) => (
                      <motion.a
                        key={a.url}
                        href={a.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.35, delay: i * 0.03 }}
                        className="group bg-[#0a0a0a]/85 backdrop-blur-sm p-5 md:p-6 flex items-start gap-4 hover:bg-[#150003] transition-colors"
                        data-testid={`press-item-${i}`}
                      >
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 text-[10px] tracking-[0.3em] uppercase text-white/45 mb-2">
                            <span className="text-[#FFDE00]/85 font-semibold">
                              {a.source}
                            </span>
                            <span className="text-white/30">· {a.date}</span>
                          </div>
                          <div className="text-sm md:text-base text-white/85 font-light leading-snug group-hover:text-[#FFDE00] transition-colors">
                            {title(a)}
                          </div>
                        </div>
                        <ArrowUpRight
                          size={16}
                          className="text-white/30 group-hover:text-[#FFDE00] shrink-0 mt-1 group-hover:rotate-12 transition-all"
                        />
                      </motion.a>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            <div className="mt-8 flex justify-center">
              <button
                onClick={() => setExpanded((v) => !v)}
                data-testid="press-toggle"
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-white/20 hover:border-[#FFDE00]/70 hover:text-[#FFDE00] transition-colors text-xs tracking-widest uppercase font-semibold"
              >
                {expanded ? (
                  <>
                    <ChevronUp size={14} />{" "}
                    {lang === "ru" ? "Свернуть" : "Show less"}
                  </>
                ) : (
                  <>
                    <ChevronDown size={14} />{" "}
                    {lang === "ru" ? "Все публикации" : "All publications"}{" "}
                    <span className="text-[#FFDE00]/80">({rest.length})</span>
                  </>
                )}
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Press;
